import * as React from 'react';
import { useIntl } from 'react-intl';

import styled, { css } from 'styled-components';

import { theme } from '@notino/react-styleguide';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

interface IFormattedDateProps {
  date: string;
}

const Span = styled.span<{ newDesign: boolean }>`
  ${({ newDesign }) =>
    newDesign &&
    css`
      color: ${theme.palette.neutralDarker};
      ${theme.typography.labelRegular400}
    `}
`;

export const FormattedDate: React.FC<IFormattedDateProps> = ({ date }) => {
  const { formatDate } = useIntl();
  const newDesign = useNewPdDesignEnabled();

  const dateObj = new Date(date);
  const dayName = formatDate(dateObj, { weekday: 'long' });
  const dayNumber = formatDate(dateObj, {
    day: 'numeric',
    month: 'numeric',
    year: newDesign ? undefined : 'numeric',
  });

  return <Span newDesign={newDesign}>{`${dayName} ${dayNumber}`}</Span>;
};
